<template>
  <section>

    <div class="left_nemu">
      <a class="tab_nume_box" :class="active_tab == '2' ? 'active_tab_style' : '' " style="margin-top: 30px" @click="homeClick">
        <img src="../assets/image/home_1.png" alt="">
        <span>大屏</span>
      </a>

      <a class="tab_nume_box" :class="active_tab == '1' ? 'active_tab_style' : '' " @click="indexClick">
        <img src="../assets/image/Black_12.png" alt="">
        <span>看板</span>
      </a>
      <a class="tab_nume_box" :class="active_tab === '3' ? 'active_tab_style' : '' " @click="chartsClick" v-if="nav_list_data.length > 0">
        <img src="../assets/image/Black_13.png" alt="">
        <span>报表</span>
      </a>
      <a class="tab_nume_box" :class="active_tab == '4' ? 'active_tab_style' : '' " @click="systemClick" v-if="nav_list_system.length > 0">
        <img src="../assets/image/Black_menu_15.png" alt="">
        <span>配置</span>
                                                                                                                              </a>
      <div class="version_box">
        <span>V 4.6.1</span>
      </div>
    </div>

    <div id="indexnav" v-if="showMenu">
      <el-row class="tac">
        <el-col>
          <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" background-color="#FAFAFA"
            text-color="#666" active-text-color="#666" :default-active="this.$route.path" @select="handleSelect"
            router :default-openeds="openeds">
            <div v-for="(item, i) in show_nav_list" :key="i" class="ul_item">
              <el-submenu v-if="item.subMenu && item.subMenu.length > 0" :index="item.index">
                <template slot="title">
                  <span slot="title" style="font-weight: bold">{{ item.menuName }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                          v-for="(g, f) in item.subMenu"
                          :key="f"
                          :index="g.subRouteName"
                          @click="showName(g.menuName , g.subRouteName)"
                          :class="path == g.subRouteName ?'active_sub' : '' "
                  >
                    <img v-if="g.uncheckedIcon" :src="path == g.subRouteName ? require('@/assets/image/'+ g.uncheckedIcon + '_active.png') : require('@/assets/image/'+ g.uncheckedIcon + '.png')" alt="" />
                    {{ g.menuName }}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </div>
          </el-menu>
        </el-col>
      </el-row>
    </div>

    <div class="transverse">
      <div class="title"><img src="../assets/image/epicas_white.png" alt=""></div>

      <div class="userInfo">
        <div class="btn_box">
          <div class="report day_report" @click="dayReport">日报</div>
          <div class="report week_report" @click="weekReport">周报</div>
        </div>

        <!--<div style="display: flex" @click="exit">
          <img src="../assets/image/Avatar.png" alt="" style="width: 24px; height: 24px;margin-top: 18px;margin-right:8px;" >
          <span v-if="orgName !== ''" style="margin-right: 8px">{{ orgName }}</span>
          <span>{{ leaderName }}</span>
        </div>-->
        <el-dropdown trigger="click">
          <div style="display: flex; cursor: pointer;">
            <img src="../assets/image/Avatar.png" alt="" style="width: 24px; height: 24px;margin-top: 18px;margin-right:8px;" >
            <span v-if="orgName !== ''" style="margin-right: 8px">{{ orgName }}</span>
            <span>{{ leaderName }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="showChangePwdDialog">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="exit">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>
    <div v-if="showMenu" class="nav_background"></div>


    <el-dialog title="日报" :visible.sync="showDayReport" width="80%">

      <div class="report_box">
        <div class="check_day">{{dayReportData.checkDay}}</div>
        <div class="report_detail">
          <div class="sa_box">
            <div class="sa_first">
              <div class="ranking"><span>第一名</span></div>
              <div class="sa_name"><span>服务顾问：{{dayReportData.firstSa}}</span></div>
              <div class="sa_rate"><span>转化率：{{dayReportData.firstConversionRate}}%</span></div>
            </div>
            <div class="sa_disparity">
              <div class="disparity_detail"><span>差距：{{dayReportData.lastPercentage}}%</span></div>
            </div>
            <div class="sa_last">
              <div class="ranking"><span>最后一名</span></div>
              <div class="sa_name"><span>服务顾问：{{dayReportData.lastSa}}</span></div>
              <div class="sa_rate"><span>转化率：{{dayReportData.lastConversionRate}}%</span></div>
            </div>
          </div>

          <div class="sa_box">
            <div class="label_box">
              <div class="label"></div>
              <div class="label">第一名</div>
              <div class="label disparity_detail">差距</div>
              <div class="label">最后一名</div>
            </div>
            <div class="item_box">
              <div class="label">总检测项目数</div>
              <div class="label">{{dayReportData.firstTotalItemsWorker}}:{{dayReportData.firstTotalItems}}</div>
              <!--<div class="label disparity_detail">{{dayReportData.lastTotalItemsPercentage}}</div>-->
              <div class="label disparity_detail">{{dayReportData.lastTotalItemsWorker ? `${dayReportData.lastTotalItemsPercentage}` : '-'}}</div>
              <div class="label">{{dayReportData.lastTotalItemsWorker ? `${dayReportData.lastTotalItemsWorker}:${dayReportData.lastTotalItems}` : '-'}}</div>
            </div>
            <div class="item_box">
              <div class="label">单车平均检测项目数</div>
              <div class="label">{{dayReportData.firstWorker}}:{{dayReportData.firstAverageDetectionItems}}</div>
              <!--<div class="label disparity_detail">{{dayReportData.lastPercentageWorker}}</div>-->
              <div class="label disparity_detail">{{dayReportData.lastWorker ? `${dayReportData.lastPercentageWorker}` : '-'}}</div>
              <div class="label">{{dayReportData.lastWorker ? `${dayReportData.lastWorker}:${dayReportData.lastAverageDetectionItems}` : '-'}}</div>
            </div>


          </div>


        </div>

        <div class="script_box">
          <div class="script_detail">
            <div class="copy_box" @click="copyScript('saScript')"><a title="复制"><i class="el-icon-document-copy"></i></a></div>
            <span>{{dayReportData.saScript}}</span>
          </div>
          <div class="script_detail">
            <div class="copy_box" @click="copyScript('workerScript')"><a title="复制"><i class="el-icon-document-copy"></i></a></div>
            <span>{{dayReportData.workerScript}}</span>
          </div>
        </div>


      </div>

    </el-dialog>


    <el-dialog title="周报" :visible.sync="showWeekReport" width="80%">

      <div class="report_box">
        <div class="report_detail">
          <div class="sa_box_week">
            <div class="week_item" style="border-bottom: 1px solid #eeeeee;padding-bottom: 20px;">
              <div class="label_box">
                <div class="label"></div>
                <div class="label">服务顾问</div>
                <div class="label">获得第一的次数</div>
                <div class="label">获得最后一名的次数</div>
              </div>
              <div class="item_box">
                <div class="label">第一名</div>
                <div class="label">{{weekReportData.firstSa}}</div>
                <div class="label">{{weekReportData.firstSaNum}}</div>
                <div class="label">-</div>
              </div>
              <div class="item_box" v-if="weekReportData.lastSa">
                <div class="label">最后一名</div>
                <div class="label">{{weekReportData.lastSa}}</div>
                <div class="label">-</div>
                <div class="label">{{weekReportData.lastSaNum}}</div>
              </div>
            </div>
            <div class="week_item">
              <!--<div class="label_box">
                <div class="label"></div>
                <div class="label">项目名称</div>
                <div class="label">服务顾问</div>
                <div class="label">成交数量</div>
                <div class="label">成交率</div>
              </div>-->
              <!--<div class="item_box" >
                <div class="label">第一名</div>
                <div class="label">{{weekReportData.saCalculateProjects.projectName}}</div>
                <div class="label">{{weekReportData.saCalculateProjects.saName}}</div>
                <div class="label">{{weekReportData.saCalculateProjects.dealNum}}</div>
                <div class="label">{{weekReportData.saCalculateProjects.dealRate}}%</div>
              </div>-->
              <!--<div class="item_box" v-for="(item,index) in weekReportData.saCalculateProjects" :key="index">
                <div class="label">第一名</div>
                <div class="label">{{item.projectName}}</div>
                <div class="label">{{item.saName}}</div>
                <div class="label">{{item.dealNum}}</div>
                <div class="label">{{item.dealRate}}%</div>
              </div>-->
              <div class="list_title"><span>单项排名第一</span></div>
              <el-table :data="weekReportData.saCalculateProjects" style="width: 100%" :height="200" :cell-style="setRowStyle" :header-cell-style="getHeaderStyle" align="center">
                <!--<el-table-column prop="date" label="第一名"> </el-table-column>-->
                <el-table-column prop="projectName" label="项目名称" > </el-table-column>
                <el-table-column prop="saName" label="服务顾问" > </el-table-column>
                <el-table-column prop="dealNum" label="成交数量" > </el-table-column>
                <el-table-column prop="dealRate" label="成交率" >
                  <template slot-scope="scope">
                    <span>{{scope.row.dealRate}}%</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>

          </div>
          <div class="sa_box_week_script">
            <div class="copy_box" @click="copyScriptWeek('saScript')"><a title="复制"><i class="el-icon-document-copy"></i></a></div>
            <span>{{weekReportData.saScript}}</span>
          </div>
        </div>


        <div class="report_detail">
          <div class="sa_box_week">
            <div class="week_item" style="border-bottom: 1px solid #eeeeee;padding-bottom: 20px;">
              <div class="label_box">
                <div class="label first"></div>
                <div class="label">检测技师</div>
                <div class="label">获得第一的次数</div>
                <div class="label">获得最后一名的次数</div>
              </div>
              <div class="item_box">
                <div class="label first">总检测项目数 第一名</div>
                <div class="label">{{weekReportData.firstWorker}}</div>
                <div class="label">{{weekReportData.firstNum}}</div>
                <div class="label">-</div>
              </div>
              <div class="item_box" v-if="weekReportData.lastWorker">
                <div class="label first">总检测项目数 最后一名</div>
                <div class="label">{{weekReportData.lastWorker}}</div>
                <div class="label">-</div>
                <div class="label">{{weekReportData.lastNum}}</div>
              </div>
              <div class="item_box">
                <div class="label first">单车平均检测项目数 第一名</div>
                <div class="label">{{weekReportData.firstAverageWorker}}</div>
                <div class="label">{{weekReportData.firstAverageNum}}</div>
                <div class="label">-</div>
              </div>
              <div class="item_box" v-if="weekReportData.lastAverageWorker">
                <div class="label first">单车平均检测项目数 最后一名</div>
                <div class="label">{{weekReportData.lastAverageWorker}}</div>
                <div class="label">-</div>
                <div class="label">{{weekReportData.lastAverageNum}}</div>
              </div>
            </div>
            <div class="week_item">
              <div class="label_box">
                <div class="label"></div>
                <div class="label">项目名称</div>
                <div class="label">完成度百分比</div>
              </div>
              <div class="item_box">
                <div class="label">检测完成度最高</div>
                <div class="label">{{weekReportData.highestCompletionProject}}</div>
                <div class="label">{{weekReportData.highestCompletionPercentage}}%</div>
              </div>
              <div class="item_box">
                <div class="label">检测完成度最低</div>
                <div class="label">{{weekReportData.lowestCompletionProject}}</div>
                <div class="label">{{weekReportData.lowestCompletionPercentage}}%</div>
              </div>
            </div>


          </div>
          <div class="sa_box_week_script">
            <div class="copy_box" @click="copyScriptWeek('workerScript')"><a title="复制"><i class="el-icon-document-copy"></i></a></div>
            <span>{{weekReportData.workerScript}}</span>
          </div>
        </div>


      </div>

    </el-dialog>


    <!-- 修改密码弹窗 -->
    <el-dialog
            title="修改密码"
            :visible.sync="changePwdVisible"
            width="400px"
            :close-on-click-modal="false">
      <el-form :model="pwdForm" ref="pwdForm" :rules="pwdRules" label-width="100px">
        <el-form-item label="用户名" >
          <el-input v-model="pwdForm.phone" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="pwdForm.newPassword" type="password" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="pwdForm.confirmPassword" type="password" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changePwdVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitChangePwd">确 定</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import net from "../assets/js/public";
import $ from "jquery";
import moment from 'moment';
import md5 from 'js-md5';
export default {
  data() {
    // 密码确认验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.pwdForm.newPassword) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };
    return {
      showMenu: false,
      leaderName: "", //用户名
      orgName: "", // 站点名称
      signInfo: "", //登录信息
      active: 1,
      openeds: ['1','2','3','4','5','6','7','8'],
      nav_list:[],
      active_tab:'1',
      path:'',

      nav_list_system: [], //店面配置管理
      nav_list_data: [], // 运营管理报表BI

      show_nav_list : [],

      showDayReport: false,
      dayReportData:{
        checkDay: '',
        firstConversionRate:'', //排名第一的顾问的转化率
        firstSa:'', //转化率排名第一的顾问
        lastSa:'', //转化率排名最后的顾问
        lastConversionRate:'', //排名最后的顾问的转化率

        lastPercentage:'', //转化率中最后一名落后第一名的百分比数量

        firstTotalItemsWorker:'', // 总检测项目数排名第一的技师
        firstTotalItems: '', // 排名第一的总检测项目数
        lastTotalItemsPercentage:'', // 总检测项目数量中最后一名落后第一名的百分比数量
        lastTotalItemsWorker: '', // 总检测项目数排名最后的技师
        lastTotalItems: '', // 排名最后的总检测项目数

        firstWorker:'', // 单车平均检测项目数的排名第一的技师
        firstAverageDetectionItems: '', // 排名第一的单车平均检测项目数
        lastPercentageWorker: '', //单车平均检测项目数中最后一名落后第一名的百分比数量
        lastWorker: '', // 单车平均检测项目数的排名最后的技师
        lastAverageDetectionItems: '', // 排名最后的单车平均检测项目数
        saScript:'',
        workerScript:'',
      },
      showWeekReport: false,
      weekReportData: {

        firstSa: '',
        firstSaNum: '',
        lastSa: '',
        lastSaNum: '',

        firstAverageWorker:'',
        firstAverageNum:'',
        lastAverageWorker:'',
        lastAverageNum:'',

        firstWorker:'',
        firstNum:'',
        lastWorker:'',
        lastNum:'',

        highestCompletionProject:'',
        highestCompletionPercentage:'',
        lowestCompletionProject:'',
        lowestCompletionPercentage:'',

        saCalculateProjects:[],

        saScript:'',
        workerScript:'',
      },


      // 修改密码相关
      changePwdVisible: false,
      pwdForm: {
        leaderId: '',
        phone: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          // { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }

    };
  },
  created() {
    this.signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
    let routeInfo = JSON.parse(sessionStorage.getItem("routeInfo"));
    if (this.signInfo == null) {
      this.$router.push({ name: "SignIn" });
      return false;
    }else {
      this.path = routeInfo && this.$route.path ==  routeInfo.path ?  routeInfo.path : this.$route.path
    }
    this.leaderName = this.signInfo.leaderName;
    this.orgName = this.signInfo.orgName;
    this.getMenuInfo();


    let remindTime = JSON.parse(localStorage.getItem("remindTime"));
    let remindWeek = JSON.parse(localStorage.getItem("remindWeek"));

    const weekday = new Date().getDay();// 获取今天周几

    if(weekday*1 !== 1){
      if(remindTime){ // 存在缓存
        // 获取今天几号
        let currentDay = new Date().getDate();
        let remindTimeDate = remindTime.remindTime.substring(8,10)

        if(currentDay*1 === remindTimeDate*1){ // 同一天
          console.log("同一天,无需再次请求")
        }else {
          this.dayReport()
        }
      }else {
        this.dayReport()
      }
    }



    if(weekday === 1){ //今天是周一
      if(!remindWeek){ // 没有缓存
        this.weekReport()
      }else { //有缓存
        if(remindWeek.weekread){ //  已读
          let remindWeek = {weekread: true,}
          localStorage.setItem("remindWeek", JSON.stringify(remindWeek));
        }else {//  未读
          this.weekReport()
        }
      }
    }else { // 周一外的其他星期
      localStorage.removeItem('remindWeek'); //删除缓存
    }


  },
  mounted() {
    // var h = document.documentElement.clientHeight - 60 + "px";
    // $("#indexnav").css({
    //   height: h
    // });


    let showInfo = JSON.parse(sessionStorage.getItem("showInfo"));
    this.active_tab = showInfo.active_tab
    if(showInfo){
      this.showMenu = showInfo.showMenu
    }



  },
  watch: {
    $route(to, from) {
      let showInfo = JSON.parse(sessionStorage.getItem("showInfo"));
      this.active_tab = showInfo.active_tab || '1'
      this.path = showInfo.routeName
      if(showInfo){
        this.showMenu = showInfo.showMenu
      }else{
        this.showMenu = false
      }

      this.getMenuInfo()

    }
  },
  methods: {

    // 显示修改密码弹窗
    showChangePwdDialog() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.changePwdVisible = true;
      this.pwdForm = {
        leaderId: signInfo.leaderId,
        phone: signInfo.phone,
        newPassword: '',
        confirmPassword: ''
      };
    },
    // 提交修改密码
    submitChangePwd() {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          console.log('submit!',this.pwdForm);
          net.request('admin/manage/staff/changePassword', 'post', null, {
            leaderId: this.pwdForm.leaderId,
            md5Password: md5(this.pwdForm.confirmPassword),
          }).then(res => {
            if (res.code === 0) {
              this.$message.success('密码修改成功，请重新登录');
              this.changePwdVisible = false;
              setTimeout(() => {
                sessionStorage.clear();
                net.delCookie("signInfo");
                this.$router.push({ path: "/" });
              }, 1500);
            } else {
              this.$message.error(res.msg || '修改失败');
            }
          });
        }
      });
    },

    getHeaderStyle() {
      // text-align: center;
      // font-size: 18px;
      // font-weight: 700;
      return "background-color:#F3F7FB; color: #364556; text-align: center;font-size: 18px;height: 48px;font-weight: 700;font-family: 'PingFang SC';";
    },
    setRowStyle(row, column, rowIndex, columnIndex) {
      return 'color: #0D0E12;font-weight: 500;font-size: 16px;text-align: center;'
    },


    // 日报
    dayReport(){
      console.log("时间变了===》请求数据&&添加缓存")
      // 日报
      net.request("manage/statisticsReport/dayReport", "get", ).then(res => {
        if(res.code === 0){
          let data = res.data
          if(data){

            let lastTotalItemsWorkerLabel = data.workerRankingVO.lastTotalItemsWorker? `总检测项目数倒数第一的检测技师是${data.workerRankingVO.lastTotalItemsWorker},总检测项目数为：${data.workerRankingVO.lastTotalItems}，和第一名的差距是${data.workerRankingVO.lastTotalItemsPercentage}，` : ''
            let lastWorkerLabel = data.workerRankingVO.lastWorkerLabel? `单车平均检测项目数倒数第一的检测技师是${data.workerRankingVO.lastWorker},单车平均检测项目数为：${data.workerRankingVO.lastAverageDetectionItems}，和第一名的差距是${data.workerRankingVO.lastPercentage}` : ''

            let dayReportData = {
              checkDay: data.checkDay,
              firstConversionRate: data.saRankingVO.firstConversionRate,
              firstSa: data.saRankingVO.firstSa, //转化率排名第一的顾问
              lastSa:data.saRankingVO.lastSa, //转化率排名最后的顾问
              lastConversionRate:data.saRankingVO.lastConversionRate, //排名最后的顾问的转化率
              lastPercentage:data.saRankingVO.lastPercentage, //转化率中最后一名落后第一名的百分比数量

              saScript : `根据统计，${data.checkDay},管控计划内转化率第一的服务顾问是${data.saRankingVO.firstSa},转化率为：${data.saRankingVO.firstConversionRate}%;
              转化率倒数第一的服务顾问是${data.saRankingVO.lastSa},转化率为：${data.saRankingVO.lastConversionRate}%，
              和第一名的差距是${data.saRankingVO.lastPercentage}%`,

              firstTotalItemsWorker:data.workerRankingVO.firstTotalItemsWorker, // 总检测项目数排名第一的技师
              firstTotalItems: data.workerRankingVO.firstTotalItems, // 排名第一的总检测项目数
              lastTotalItemsPercentage:data.workerRankingVO.lastTotalItemsPercentage, // 总检测项目数量中最后一名落后第一名的百分比数量
              lastTotalItemsWorker: data.workerRankingVO.lastTotalItemsWorker, // 总检测项目数排名最后的技师
              lastTotalItems: data.workerRankingVO.lastTotalItems, // 排名最后的总检测项目数

              firstWorker:data.workerRankingVO.firstWorker, // 单车平均检测项目数的排名第一的技师
              firstAverageDetectionItems: data.workerRankingVO.firstAverageDetectionItems, // 排名第一的单车平均检测项目数
              lastPercentageWorker: data.workerRankingVO.lastPercentage, //单车平均检测项目数中最后一名落后第一名的百分比数量
              lastWorker: data.workerRankingVO.lastWorker, // 单车平均检测项目数的排名最后的技师
              lastAverageDetectionItems: data.workerRankingVO.lastAverageDetectionItems, // 排名最后的单车平均检测项目数


              workerScript : `根据统计，${data.checkDay},管控计划内总检测项目数第一的检测技师是${data.workerRankingVO.firstTotalItemsWorker},总检测项目数为：${data.workerRankingVO.firstTotalItems}，
              ${lastTotalItemsWorkerLabel}

              单车平均检测项目数第一的检测技师是${data.workerRankingVO.firstWorker},单车平均检测项目数为：${data.workerRankingVO.firstAverageDetectionItems}，
              ${lastWorkerLabel}
              `
            }
            this.dayReportData = dayReportData
            this.showDayReport = true

            let remindTime = {
              remindTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
              read: true,
            }
            localStorage.setItem("remindTime", JSON.stringify(remindTime));
          }else {
            net.message(this, res.msg, "warning");
          }


        }else {
          net.message(this, res.msg, "warning");
        }
      })

    },
    // 周报
    weekReport(){
      console.log("请求周报")
      net.request("manage/statisticsReport/weekReport", "get", ).then(res => {
        if(res.code === 0){
          let data = res.data
          if(data){
            let saCalculateProjects = data.saCalculateProjects

            let lastSaLabel = data.lastSa?`获取最后一名次数最多的服务顾问是${data.lastSa},获得最后一名的次数是${data.lastNum},`:''
            let labelList= ''
            saCalculateProjects.forEach(item => {
              labelList += `成交项目为${item.projectName},${item.saName}的成交数量为：${item.dealNum},成交率为：${item.dealRate}%，`
            })
            let saScript = `根据统计，周一至周日获得第一的次数最多的服务顾问是${data.firstSa},总共获得了${data.firstSaNum}次,${lastSaLabel}


            重点管控项目内，本周销售各个单项排名第一的项目如下：
            ${labelList}`

            let lastWorkerLabel = data.lastWorker ? `获取最后一名次数最多的技师是${data.lastWorker},获得最后一名的次数是${data.lastNum}，` : ''
            let lastAverageWorkerLabel = data.lastAverageWorker ? `获取最后一名次数最多的技师${data.lastAverageWorker},获得最后一名的次数是${data.lastAverageNum}，` : ''

            let workerScript = `根据统计，周一至周日, 总检测项目数获取第一名次数最多的技师是${data.firstWorker},获得了${data.firstNum}次、
            ${lastWorkerLabel}
            单车平均检测项目数获取第一名次数最多的技师是${data.firstAverageWorker},获得了${data.firstAverageNum}次、
            ${lastAverageWorkerLabel}

            重点管控项目内本周检测完成度最高的项目是${data.highestCompletionProject}，完成度是${data.highestCompletionPercentage}%、
            完成度最低的项目是${data.lowestCompletionProject}，完成度是${data.lowestCompletionPercentage}%`
            let weekReportData = {
              saCalculateProjects: saCalculateProjects,

              firstWorker:data.firstWorker,
              firstNum:data.firstNum,
              lastWorker:data.lastWorker,
              lastNum:data.lastNum,

              firstAverageWorker:data.firstAverageWorker,
              firstAverageNum:data.firstAverageNum,
              lastAverageWorker:data.lastAverageWorker,
              lastAverageNum:data.lastAverageNum,

              firstSa: data.firstSa,
              firstSaNum: data.firstSaNum,
              lastSa: data.lastSa,
              lastSaNum: data.lastSaNum,

              highestCompletionProject:data.highestCompletionProject,
              highestCompletionPercentage:data.highestCompletionPercentage,
              lowestCompletionProject:data.lowestCompletionProject,
              lowestCompletionPercentage:data.lowestCompletionPercentage,

              saScript:saScript,
              workerScript:workerScript,

            }
            this.weekReportData = weekReportData

            let remindWeek = {weekread: true,}
            localStorage.setItem("remindWeek", JSON.stringify(remindWeek));
            this.showWeekReport = true
          }else {
            net.message(this, res.msg, "warning");
          }



        }else {
          net.message(this, res.msg, "warning");
        }
      })
    },
    //复制日报
    copyScript(label){
      // let authCode = row.authCode
      let oInput = document.createElement('input');
      oInput.value = this.dayReportData[label];
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      oInput.remove()
    },
    //复制周报
    copyScriptWeek(label){
      let oInput = document.createElement('input');
      oInput.value = this.weekReportData[label];
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      oInput.remove()
    },

    // 点击菜单
    showName(name, subRouteName){
      this.path = subRouteName
      let showInfo = JSON.parse(sessionStorage.getItem("showInfo"));
      showInfo.routeName = subRouteName
      sessionStorage.setItem("showInfo", JSON.stringify(showInfo));
    },

    // 获取路由菜单
    getMenuInfo() {
      // let param = { roleId: 1 };
      let param = { roleId: this.signInfo.roleId };
      net.request("admin/manage/role/getMenu", "post", param).then(res => {
        if (res.retcode == 1) {
          let data = res.data
          this.nav_list = data
          data.forEach(item => {
            item.index = item.id+''
          })

          let nav_list_system = [] //店面配置管理
          let nav_list_data = [] //运营管理报表BI
          for(let i = 0; i < data.length; i++){
            if(data[i].menuType*1 === 0){ // 配置
              nav_list_system.push(data[i])
            }else { //报表
              nav_list_data.push(data[i])
            }
          }

          this.nav_list_system = nav_list_system;
          this.nav_list_data = nav_list_data;

          this.openeds_system = [nav_list_system[0].index]
          this.openeds_data = [nav_list_data[0].index]

          let showInfo = JSON.parse(sessionStorage.getItem("showInfo"));
          let active_tab = showInfo.active_tab
          if(active_tab * 1 === 1){ // 看板
            this.$router.push({ path: "/manageMain" })
          }else if(active_tab * 1 === 2){ //数据大屏
            this.$router.push({ path: "/homeMain" })
          }else if(active_tab * 1 === 3){
            this.show_nav_list = nav_list_data
            if(this.$route.name == 'index'){
              this.$router.push({ path: "/OperationDataStatistics" });
              this.openeds = this.openeds_data
              this.path = nav_list_data[0].subMenu[0].subRouteName
            }
          }else if(active_tab * 1 === 4){
            this.show_nav_list = nav_list_system
            if(this.$route.name == 'index'){
              this.openeds = this.openeds_system
              this.path = nav_list_system[0].subMenu[0].subRouteName
              this.$router.push({ path: nav_list_system[0].subMenu[0].subRouteName });
            }
          }
          this.active_tab = showInfo.active_tab
          sessionStorage.setItem("navList", JSON.stringify(res));
        }
      });
    },

    // 展开菜单
    handleOpen(index, indexPath) {
      let name = this.$route.name
      if(index == 4 && name != 'OperationDataStatistics'){
        this.$router.replace({name:'OperationDataStatistics'})
      }
      if(index == 6 && name != 'BIreport'){
        this.$router.replace({name:'BIreport'})
      }
      if(index == 14 && name != 'inCommonUse'){
        this.$router.replace({name:'inCommonUse'})
      }
    },
    // 收起菜单
    handleClose(index, indexPath){
      let name = this.$route.name
      if(index == 4 && name != 'OperationDataStatistics'){
        this.$router.replace({name:'OperationDataStatistics'})
      }
      if(index == 6 && name != 'BIreport'){
        this.$router.replace({name:'BIreport'})
      }
      if(index == 14 && name != 'inCommonUse'){
        this.$router.replace({name:'inCommonUse'})
      }
    },
    // 激活菜单
    handleSelect(index, indexPath) {
      this.path = index
      let subMenuId = ''
      let nav_list = this.nav_list
      for(let i = 0; i < nav_list.length; i++){
        if(nav_list[i].subMenu){
          for(let j = 0; j < nav_list[i].subMenu.length; j++){
            if(nav_list[i].subMenu[j].subRouteName === index){
              subMenuId = nav_list[i].subMenu[j].id
            }
          }
        }

      }
      let params = {
        type:0,
        content: subMenuId
      }
      net.request("admin/manage/collectAction/addAction", "post",null, params).then(res => {
        if (res.retcode === 1) {
          console.log('统计菜单点击')
        } else {
          net.message(this, res.retmsg, "warning");
        }
      })

    },
    // 退出登录
    exit() {
      this.$confirm("是否确认退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出成功!"
          });
          sessionStorage.clear();
          net.delCookie("signInfo");
          this.$router.push({ path: "/" });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

    // 首页
    homeClick(){
      this.active_tab = '2'
      this.$router.push({ path: "/homeMain" });
      this.showMenu = false;
      this.$emit('MainPageChanged', 0)

      let showInfo = {
        showMenu: false,
        active_tab:'2'
      }
      sessionStorage.setItem("showInfo", JSON.stringify(showInfo));
    },
    // 预检工单管理
    indexClick() {
      this.active_tab = '1'
      this.$router.push({ path: "/manageMain" });
      this.showMenu = false;
      this.$emit('MainPageChanged', 1)

      let showInfo = {
        showMenu: false,
        active_tab:'1'
      }
      sessionStorage.setItem("showInfo", JSON.stringify(showInfo));
    },

    // 系统配置管理
    systemClick(){
      this.active_tab = '4'
      this.openeds = this.openeds_system
      this.showMenu = true;
      this.$emit('MainPageChanged', 4)

      let nav_list = this.nav_list_system
      this.show_nav_list = nav_list
      this.path = nav_list[0].subMenu[0].subRouteName
      this.$router.push({ path: nav_list[0].subMenu[0].subRouteName });

      let showInfo = {
        showMenu: true,
        active_tab:'4',
        showChart:false,
        showData: false,
        showSystem: true,
        routeName: nav_list[0].subMenu[0].subRouteName
      }
      sessionStorage.setItem("showInfo", JSON.stringify(showInfo));
    },
    // 运营管理报表BI
    chartsClick(){
      this.active_tab = '3'
      this.showMenu = true;
      this.openeds = this.openeds_data
      let nav_list_data = this.nav_list_data
      this.show_nav_list = nav_list_data

      this.$router.push({ path: "/inCommonUse" });
      this.path = "/inCommonUse"
      this.$emit('MainPageChanged', 3)
      let showInfo = {
        showMenu: true,
        showData: true,
        showChart: false,
        showSystem: false,
        active_tab:'3'
      }
      sessionStorage.setItem("showInfo", JSON.stringify(showInfo));

    },
  }
};
</script>
<style lang="less" scoped>
section {
  width: 100%;
  height: 0;
  overflow: auto;
  .left_nemu {
    width: 80px;
    height: calc(100% - 60px);
    position: absolute;
    margin-top: 60px;
    background: #2B54FC;
    .version_box {
      width: 100%;
      text-align: center;
      font-size: 12px;
      color: #fff;
      font-weight: 400;
      position: absolute;
      bottom: 4px;
    }
  }
  .tab_nume_box {
    width: 48px;
    height: 48px;
    margin-left: 16px;
    margin-bottom: 35px;
    color: #C3C6CF;
    text-align: center;
    font-size: 10px;
    display: flex;
    flex-flow: column;
  }
  .tab_nume_box img {
    width: 24px;
    height: 24px;
    margin-left: 12px;
    margin-bottom: 3px;
    margin-top: 6px;
  }
  .active_tab_style {
    width: 48px;
    height: 48px;
    margin-left: 16px;
    background: rgba(255, 255, 255, 0.2);
    border: 1px solid rgba(255, 255, 255, 0.16);
    border-radius: 8px;
    color: #fff;
  }
  .el-menu-item-group__title {
    display: none;
  }
  #indexnav::-webkit-scrollbar {
    display: none;
  }
  #indexnav {
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    position: absolute;
    height: calc(100vh - 65px);
    top: 0px;
    left: 80px;
    padding-top: 60px;
    width: 200px;
    z-index: 11;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    margin-right: -15px;
    .el-menu {
      border-right:0;
      text-align: left;
    }
    .el-menu-vertical-demo {
      .ul_item {
        /*width: 95%;*/
        text-align: left;
        /*border-bottom: 1px solid #EBEBEB;*/
        /*.el-submenu {*/
        /*width: 95%;*/
        /*margin-left: 5%;*/
        /*}*/
      }
    }

    .iconfont {
      font-size: 20px !important;
      display: inline-block;
      margin-right: 3px;
      color: #666 !important;
    }

    .el-menu-item-group .is-active {
      width: 90%;
      background:  linear-gradient(138.05deg, rgba(43, 84, 252, 1) 13.89%, rgba(47, 224, 253, 1) 100%) !important;
      border-radius: 0 8px 8px 0;
      color: #fff !important;
      /*box-shadow: 8px -9px 18px 0px rgba(127, 133, 154, 0.16);*/
      /*img {*/
        /*filter: grayscale(100%) brightness(500%);*/
      /*}*/
    }
    .active_sub {
      width: 90%;
      background:  linear-gradient(138deg,rgba(43, 84, 252, 1) 13.89%, rgba(47, 224, 253, 1) 100%);
      border-radius: 0 8px 8px 0;

      color: #fff !important;
      /*img {
        filter: grayscale(100%) brightness(500%);
      }*/
    }

    .el-menu-item-group__title {
      display: none !important;
    }

    .el-submenu .el-menu-item {
      height: 48px;
      width: 90%;
      /*margin-left: 5%;*/
      line-height: 48px;
      text-align: left;
      padding-left: 18px !important;
      img{
        width: 24px;
        margin-right: 10px;
      }
    }
  }
  .transverse {
    width: 100%;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    background: #FFFFFF;
    box-shadow: inset 0px -1px 0px rgba(113, 129, 162, 0.1);
    color: #0D0E12;
    line-height: 60px;
    z-index: 12;
    display: flex;
    justify-content: space-between;
    line-height: 60px;
    float: left;
    display: flex;
    flex-direction: row;


    .topNavButton1 {
      position: absolute;
      top: 0;
      left: 220px;
      width: 100px;
      border-left: 1px solid #000;
      border-right: 1px solid #000;
      height: 60px;
      padding: 0;
      cursor: pointer;
    }

    .topNavButton2 {
      position: absolute;
      top: 0;
      left: 322px;
      width: 100px;
      border-right: 1px solid #000;
      height: 60px;
      cursor: pointer;
    }
    .topNavButton3 {
      position: absolute;
      top: 0;
      left: 424px;
      width: 100px;
      border-right: 1px solid #000;
      height: 60px;
      cursor: pointer;
    }
    .title {
      width: 80px;
      color: #009688;
      text-align: center;
      overflow: hidden;
      background: #2B54FC;
    }

    .portrait {
      width: 40px;
      height: 40px;
      position: absolute;
      right: 261px;
      top: 10px;

      img {
        display: inline-block;
        width: 100%;
        border-radius: 50%;
      }
    }

    .userInfo {
      font-size: 14px;
      display: flex;
      .btn_box {
        width: 160px;
        display: flex;
        margin-right: 20px;
        align-items: center;
        .report {
          cursor: pointer;
          width: 46%;
          height: 36px;
          line-height: 36px;
          text-align: center;
          margin-right: 8%;
          color: #fff;
          border-radius: 8px;
        }
        .day_report {
          background-color: #409EFF;
        }
        .week_report {
          background-color: #909399;
        }
      }

      span {
        color: #0D0E12;
        display: inline-block;
        margin-right: 40px;
        font-size: 14px;
      }

    }

    .message {
      display: inline-block;
      width: 49%;
    }
  }
  .nav_background {
    position: absolute;
    top: 0;
    left: 80px;
    width: 200px;
    min-height: 300px;
    height: 100%;
    max-width: 3000px;
    background: #FAFAFA;
    z-index: 10;
  }

  /*日报*/
  .report_box {
    .check_day {
      width: 100%;
      height: 70px;
      line-height: 70px;
      text-align: center;
      font-size: 28px;
      font-weight: 700;
    }
    .report_detail {
      display: flex;
      justify-content: space-between;
      margin-bottom: 50px;
    }
    /* 日报*/
    .sa_box {
      width: 48%;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      .sa_first {
        display: flex;
        width: 100%;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        font-weight: 700;
        .ranking{
          width: 20%;
        }
        .sa_name {
          width: 40%;
        }
        .sa_rate {
          width: 40%;
        }
      }
      .sa_disparity {
        width: 100%;
        height: 100px;
        line-height: 100px;
        font-size: 28px;
        font-weight: 700;
        color: #E6A23C;
      }
      .sa_last {
        display: flex;
        width: 100%;
        height: 48px;
        line-height: 48px;
        font-size: 18px;
        font-weight: 700;
        .ranking{
          width: 20%;
        }
        .sa_name {
          width: 40%;
        }
        .sa_rate {
          width: 40%;
        }
      }

      /*技师*/
      .label_box {
        display: flex;
        background: #f5f7fa;
        .label {
          width: 25%;
          height: 48px;
          line-height: 48px;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
        }
        .disparity_detail {
          font-size: 28px;
          color: #E6A23C;
        }
      }
      .item_box {
        display: flex;
        .label {
          width: 25%;
          height: 48px;
          line-height: 48px;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
        }
        .disparity_detail {
          font-size: 28px;
          color: #E6A23C;
        }
      }
    }

    .sa_box_week {
      width: 70%;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      .label_box , .item_box{
        display: flex;
        .label {
          width: 20%;
          height: 48px;
          line-height: 48px;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
        }
      }
      .label_box {
        background: #f5f7fa;
      }
      .week_item {
        width: 98%;
        margin-left: 1%;
        margin-top: 20px;
        margin-bottom: 20px;
        .list_title {
          background: #f5f7fa;
          height: 48px;
          line-height: 48px;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
        }
        .label {
          width: 33.33%;
          height: 48px;
          line-height: 48px;
          text-align: center;
          font-size: 18px;
          font-weight: 700;
        }
        .first {
          width: 50%;
        }
      }
    }
    .sa_box_week_script {
      position: relative;
      box-sizing: border-box;
      width: 28%;
      padding: 20px 12px;
      display: flex;
      flex-flow: column;
      justify-content: space-between;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      text-align: left;
      line-height: 30px;
      .copy_box {
        position: absolute;
        right: 2px;
        top: -2px;
        font-size: 18px;
      }
    }

    .script_box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 50px;
      .script_detail {
        position: relative;
        box-sizing: border-box;
        width: 48%;
        padding: 20px 12px;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        border-radius: 4px;
        border: 1px solid #ebeef5;
        background-color: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        text-align: left;
        line-height: 30px;
        .copy_box {
          position: absolute;
          right: 2px;
          top: -2px;
          font-size: 18px;
        }
      }
    }
  }



}
</style>
<style>

  /*.el-submenu__icon-arrow {!* 隐藏菜单的收起展开*!
    !*display: none !important;*!
  }
  .el-menu-item:hover {
    !*background: #FFFFFF !important;*!
    border-radius: 8px;
    color: #0D0E12;
  }*/
</style>
